























import Vue, {PropOptions} from 'vue';
// @ts-ignore
import SvgPrint from '@/common/svgs/print.svg';
import SvgIcon from '@/configurator/components/utils/SvgIcon.vue';
import {formatPrice} from '@/common/utils/helper';
import {KernelPart, KernelPartList} from '@roomle/web-sdk/lib/definitions/typings/kernel';
import {prepareParametersForUi} from '@/common/utils/parameters';
import PrimaryButton from '@/configurator/components/utils/PrimaryButton.vue';

export default Vue.extend({

  components: {
    SvgIcon,
    PrimaryButton,
  },

  props: {
    partList: Array as PropOptions<KernelPartList[]>,
    price: String,
    perspectiveImage: String,
    label: String,
    bounds: String,
    catalogLabel: String,
  },

  destroyed() {
    this.isGenerating = false;
  },

  data() {
    return {
      isGenerating: false,
    };
  },

  computed: {
    icons(): object {
      return {
        SvgPrint,
      };
    },
  },

  methods: {
    printModal() {
      window.print();
    },
    async print() {
      if (this.isGenerating) {
        return;
      }
      this.isGenerating = true;
      const {jsPDF, autoTable} = await this.$libs.getJsPdf();
      const doc = new jsPDF();
      const generateData = (partList: KernelPart[]) => {
        return partList.map(({articleNr = '', label: partLabel = '', count = '', price: partPrice, currencySymbol, parameters}) => [
          articleNr,
          // tslint:disable-next-line:max-line-length
          partLabel + prepareParametersForUi(parameters).reduce((acc, {label: parameterLabel, valueLabel, key, value}: any /* need to cast to any because SDK didnt type "key" but we get a "key" */) => {
            if (acc === '') {
              acc = '\n';
            }
            acc += '       ' + (parameterLabel || key) + ': ' + (valueLabel || value) + '\n';
            return acc;
          }, ''),
          count.toLocaleString(),
          /**
           * replace whitespace because auto-table calcs width of utf chars wrong
           * and therefore line breaks in-between currency symbol. Instead of "€ 4,00"
           * it shows "€
           * 4,00" (if the table is fully filled, e.g.: long labels etc)
           */
          formatPrice(currencySymbol, partPrice)?.replace(' ', '') || '',
        ]) || [];
      };

      const labelCustom = this.catalogLabel || (this as any).t.t('print.custom');
      const labelPage = (this as any).t.t('print.page');
      const labelOf = (this as any).t.t('print.of');
      const startX = 14;
      const startY = 22;
      const bigFont = 22;
      const mediumFont = 18;
      const regularFont = 11;
      const smallFont = 9;
      const mediumPadding = 5;
      doc.addFont('./print/fonts/lato-regular.ttf', 'Lato', 'normal');
      doc.setFont('Lato');
      doc.setFontSize(bigFont);
      doc.text(this.label, startX, startY);
      doc.setFontSize(regularFont);
      doc.text(labelCustom, startX, startY + mediumPadding);

      const imageWidthMm = 50;
      doc.addImage(this.perspectiveImage, 'PNG', doc.internal.pageSize.getWidth() - imageWidthMm - startX, startY - bigFont, imageWidthMm, imageWidthMm);

      if (this.bounds) {
        doc.text(this.bounds, startX, startY + mediumPadding * 4);
      }

      if (this.price) {
        doc.setFontSize(mediumFont);
        doc.text(this.price, startX, startY + mediumPadding * 2.5);
      }

      (doc as any).autoTableSetDefaults({
        headStyles: {fillColor: [64, 64, 64]},
      });

      const totalPagesExp = '{total_pages_count_string}';
      this.partList.forEach(({fullList, originPart}, index) => {
        const tableContent = generateData(fullList);

        const headers = [
          (this as any).t.t('article-nr'),
          (this as any).t.t('part-list.label'),
          (this as any).t.t('count'),
        ];
        const price = this.price;
        if (price) {
          headers.push((this as any).t.t('part-list.price'));
        }
        const headersLength = headers.length;
        const startYMainComponent = (index === 0) ? startY + mediumPadding * 4 : (doc as any).lastAutoTable.finalY + mediumPadding;
        autoTable(doc, {
          head: [
            [{
              content: originPart.label,
              colSpan: headersLength,
              // for options see: https://github.com/simonbengtsson/jsPDF-AutoTable#styling-options
              styles: {
                cellPadding: {top: 5, right: 0, bottom: 5, left: 0},
                fontSize: 12,
                fontStyle: 'bold',
                textColor: [0, 0, 0],
                fillColor: [255, 255, 255],
              },
            }],
            headers,
          ],
          body: tableContent,
          theme: 'grid',
          startY: startYMainComponent + mediumPadding,
          styles: {
            font: 'Lato',
          },
          rowPageBreak: 'avoid',
          didDrawPage(data) {
            // recipe from https://simonbengtsson.github.io/jsPDF-AutoTable/#header-footer
            let str = labelPage + ' ' + (doc.internal as any).getNumberOfPages();
            if (typeof doc.putTotalPages === 'function') {
              str = str + ' ' + labelOf + ' ' + totalPagesExp;
            }
            doc.setFontSize(smallFont);
            const pageSize = doc.internal.pageSize;
            const pageHeight = pageSize.getHeight();
            doc.text(str, data.settings.margin.left, pageHeight - smallFont);
          },
        });
      });
      if (typeof doc.putTotalPages === 'function') {
        doc.putTotalPages(totalPagesExp);
      }
      doc.save(this.label + ' ' + labelCustom + '.pdf');
      this.isGenerating = false;
    },
  },

});
